import React from 'react';
import './DateSelector.css';

interface DateSelectorProps {
  availableDates: string[];
  selectedDate: string | null;
  onDateSelect: (date: string) => void;
}

const DateSelector: React.FC<DateSelectorProps> = ({
  availableDates,
  selectedDate,
  onDateSelect
}) => {
  if (availableDates.length === 0) {
    return (
      <div className="date-selector">
        <p className="no-dates">Brak dostępnych dat</p>
      </div>
    );
  }

  return (
    <div className="date-selector">
      <label htmlFor="date-dropdown" className="date-label">
        Wybierz datę:
      </label>
      <select
        id="date-dropdown"
        className="date-dropdown"
        value={selectedDate || ''}
        onChange={(e) => onDateSelect(e.target.value)}
      >
        <option value="">-- Wybierz datę --</option>
        {availableDates.map(date => (
          <option key={date} value={date}>
            {formatDate(date)}
          </option>
        ))}
      </select>
    </div>
  );
};

const formatDate = (dateString: string): string => {
  try {
    return new Date(dateString).toLocaleDateString('pl-PL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch {
    return dateString;
  }
};

export default DateSelector;